import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles"; 
import React from "react";
import CustomButton from "../Button";
import "./alertAccount.scss";

function AlertAccount(props) {
  const {
    handleClose,
    isOpen,
    firstText,
    secondText,
    title,
    titleStyle,
    firstTextDialogStyle,
    hideDoneButton,
    children,
    testId,
  } = props;

  const StyledDialog = styled(Dialog)(() => ({
    "& .MuiDialog-scrollPaper": {
      padding: "0 16px",
    },
    "& .MuiDialog-paperFullWidth": {
      minWidth: "100%",
    },
  }));
  return (
    <StyledDialog
      fullWidth
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      data-cy={testId}
    >
      <div className="popup-account-sts-container">
        <DialogTitle sx={{ padding: "24px 16px 0px" }}>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "700",
              lineHeight: 1.4, //28px
              color: "#000",
            }}
            style={titleStyle}
          >
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{ flex: "1 1 auto", padding: "0 16px 24px", overflowY: "auto" }}
          style={firstTextDialogStyle}
        >
          <Typography
            sx={{
              color: "#333",
            }}
          >
            {firstText}
          </Typography>
          <Typography sx={{ marginTop: "16px" }}>{secondText}</Typography>
        </DialogContent>

        <DialogActions
          sx={{
            padding: "0px 16px 24px",
            margin: 0,
            display: "flex",
            flexDirection: "row",
            alignItem: "center",
          }}
        >
          {hideDoneButton ? null : (
            <CustomButton
              text={"Done"}
              color="#fff"
              backgroundColor="#1278cc"
              onClick={handleClose}
            />
          )}

          {children}
        </DialogActions>
      </div>
    </StyledDialog>
  );
}
export default AlertAccount;
